/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-21 09:22
 * @LastEditors: 许 文强 wenqiang.xu@ginlong.com
 * @LastEditTime: 2026-02-11 15:40:04
 * @FilePath: \glyun_web_vue3\src\router\index.js
 * @Description: 路由
 */
import { createRouter, createWebHistory } from 'vue-router'
// console.log("🚀 ~ createWebHistory:", createWebHistory)
import { useUserStore } from '@/stores/user'
import { useSystemConfigStore } from '@/stores/system'
import { systemConfigGlobalV2 } from '@/api/system'
import { userFind } from '@/api/login';
import i18n from '@/lang' // 导入你的 i18n 实例
import { loadLanguageAsync } from '@/lang'
import { getLang } from '@/utils/changeSystem/index.js'
import { userLogout1 } from "@/api/user/index.js"
import WujieVue from 'wujie-vue3'
import { ElMessageBox } from 'element-plus'
// 通讯无界bus
const { bus } = WujieVue

const t = i18n.global.t
import login from './login.js'
import oldMenu from './oldMenu.js'
import navMenu from './navMenu.js'
import overview from './overview.js'
import maintenance from './maintenance.js'
import report from './report.js'
import service from './service.js'
import operation from './operation.js'
import intelligentMaintenance from './intelligentMaintenance.js'
import otaUpgrade from './otaUpgrade.js'
import intelligentQuery from './intelligentQuery.js'
import other from './other.js'
import largeScreen from './largeScreen.js'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    ...oldMenu,
    ...login,
    {
      path: "/gl-table",
			name: "gl-table",
			component: () => import('../views/demo/test.vue'),
		},
    {
			path: "/gl-filter",
			name: "gl-filter",
			component: () => import('../views/demo/testFilterBox.vue'),
    },
    {
			path: "/my-echart-demo",
			name: "my-echart-demo",
			component: () => import('../views/demo/myEchartDemo.vue'),
		},
    ...navMenu,
    ...overview,
    ...maintenance,
    ...report,
    ...service,
    ...operation,
    ...intelligentMaintenance,
    ...otaUpgrade,
    ...intelligentQuery,
    ...other,
    ...largeScreen,
    // ...station,
    {
      path: '/demo',
      name: 'demo',
      // component: resolve => require(['../views/headerMenu/home.vue'], resolve),
      component: () => import('../views/demo/demo.vue'),
    },
    {
      path: '/demo1',
      name: 'demo1',
      // component: resolve => require(['../views/headerMenu/home.vue'], resolve),
      component: () => import('../views/demo/index.vue'),
    },
    {
      path: '/service/warrantyService/extendedWarrantyQueryNoLogin',
      name: 'extendedWarrantyQueryNoLogin',
      component: () => import('../views/service/extendedWarranty/noLogin/warrantyQueryNoLogin.vue'),
    },  // 官网质保
    // {//服务=》延保订单详情
    //   path: '/service/extendedWarrantOrderDetailNoLogin/:orderId',
    //   name: 'serviceExtendedWarrantyOrderDetailNoLogin',
    //   redicrect: '/service/extendedWarrantOrderDetailNoLogin/:orderId',
    //   component: () => import('../views/service/extendedWarranty/noLogin/orderDetailNoLogin.vue'),
    //   meta: {
    //     title: 'v2_early_warning_details',
    //   },
    // },
    {//延保订单详情-官网
      path: '/officialWebsite/extendedWarrantyOrderDetail/:orderId',
      name: 'extendedWarrantyOfficialWebsiteOrderDetail',
      // redicrect: '/order/extendedWarrantyOrderDetai/:orderPageType/:orderId',
      component: () => import('../views/service/extendedWarranty/common/orderDetail.vue'),
      meta: {
        title: 'v2_early_warning_details',
      },
    },
    {
      path: '/uiChange/permission',
      name: 'uiChangePermission',
      component: () => import('../views/UIChange/permission.vue'),
      meta: {
        title: ''
      }
    },
    {
			path: '/service/createExtendedWarrantyOrderNoLogin',
      name: 'createExtendedWarrantyOrderNoLogin',
			component: () => import('../views/service/extendedWarranty/noLogin/createOrderNoLogin.vue'),
		}, // 官网创建订单
    {
      path: '/service/checkStandNoLogin/:id',
      name: 'checkStandNoLogin',
      component: () => import('../views/service/checkStandNoLogin/index.vue'),
    },  // 官网收银台
    {
      path: '/service/domesticPayNoLogin/:id',
      name: 'domesticPayNoLogin',
      component: () => import('../views/service/checkStandNoLogin/domesticPayNoLogin.vue'),
    },  // 收银台 - 国内支付承载页
  ],
})

let isInitPage = true
router.beforeEach((to, from, next) => {
  console.log("🚀 ~ router.beforeEach ~ to, from, to.query.glyun_vue2:", to, from, to.query.glyun_vue2)
  const lang = getLang()
  if (to.hash && isInitPage) {
    isInitPage = false
    to.href = to.hash.replace('#/', '/')
    router.replace(to.href)
    return
  }

  loadLanguageAsync(lang).then(() => {
    if (!useSystemConfigStore().config.odmConfig || ['/login','/modify_password','/thirdLogin'].includes(to.path)) {
      systemConfigGlobalV2()
        .then((res) => {
          if (res.code === '0') {
            console.log(1)
            const systemConfigStore = useSystemConfigStore()
            systemConfigStore.setSystemConfig(res.data) // 保存用户信息到Store
            authenticationAuthority(to, next)
            // const odmConfig = res.data.odmConfig
            // document.title = odmConfig.registerInstallerTipWebsiteName +' ' + t('v2_login_login')   //设置网页title
          }
        })
        .catch((error) => {
          console.error('Error fetching user info:', error)
          authenticationAuthority(to, next)
        })
    } else {
      authenticationAuthority(to, next)
    }
  })
})
async function authenticationAuthority(to, next) { 
  // 需要登录的路由
  const userStore = useUserStore();
  const systemConfigStore = useSystemConfigStore();
  const registerInstallerTipWebsiteName = systemConfigStore.config.odmConfig?.name
  const routeAuthCodeArr = to.meta.routeAuthCode || []
  // if (to.meta.routeAuthCode && !userStore.isLoggedIn) {
  // console.log("🚀 ~ to.meta.routeAuthCode && !userStore.isLoggedIn:", to.meta.routeAuthCode, !userStore.isLoggedIn, hasPermission(routeAuthCodeArr), routeAuthCodeArr)
  // console.log("🚀 ~ userStore.userInfo.useNew:", userStore.userInfo.useNew)
  let result = await payCallback(userStore, to, next);
  // 如果为true
  if(result){ return; }
  if (to.meta.routeAuthCode && !userStore.isLoggedIn) {
    next('/login'); // 重定向到登录页
    document.title = registerInstallerTipWebsiteName
  } else if(to.meta.routeAuthCode && !hasPermission(routeAuthCodeArr)){
    // console.log("跳转403页面",to.meta.routeAuthCode, routeAuthCodeArr, hasPermission(routeAuthCodeArr))
    next("/403");
    document.title = to.meta.title ? `${t(to.meta.title)} - ${registerInstallerTipWebsiteName}` : registerInstallerTipWebsiteName
  // } else if(to.path.startsWith("/overview/") && !userStore.userInfo.useNew){
  //   next("/station");
  //   document.title = to.meta.title ? `${t(to.meta.title)} - ${registerInstallerTipWebsiteName}` : registerInstallerTipWebsiteName
  } else if((to.meta.routeAuthCode && hasPermission(routeAuthCodeArr) || !to.meta.routeAuthCode)  && localStorage.getItem('requires_password_change') && to.path !== "/modify_password" ){
    localStorage.removeItem('requires_password_change')
    userLogout1().then(res => {
      if(res?.code == 0){
        userStore.logout()
      }
    })
    next("/login");
    document.title = to.meta.title ? `${t(to.meta.title)} - ${registerInstallerTipWebsiteName}` : registerInstallerTipWebsiteName
  } else {
    next();
    document.title = to.meta.title ? `${t(to.meta.title)} - ${registerInstallerTipWebsiteName}` : registerInstallerTipWebsiteName
    // console.log("🚀 ~ authenticationAuthority ~ document.title:", document.title)
  }

  // 针对在父应用中使用纯旧版（子应用）的UI情况下，由于主应用路由不会改变，所以需要手动处理页面标签名称（通过子应用emit出来）
  if(userStore.userInfo.useNew === 0){
    bus.$on("childAppRouteChange", (title) => {
      document.title = `${t(title)} - ${registerInstallerTipWebsiteName}`
    });
  }
}
// 智能运维-设备升级弹窗全局提示
router.afterEach((to) => {
	const cfg = to.meta?.confirmConfig || {}
	if (!to.meta?.confirmOnEnter) return
	nextTick(()=>{
    ElMessageBox.confirm(
      t(cfg?.message) || '该功能仅用于固件开发人员测试，如需上传正式固件请前往新版OTA升级',
      t(cfg?.title) || t('v2_inverter_details_tip'),
      {
        confirmButtonText: t(cfg?.confirmButtonText) || '立即前往',
        cancelButtonText: t(cfg?.cancelButtonText) || "取消",
        customClass: 'my-custom-animation',
        closeOnClickModal: cfg.closeOnClickModal,
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: Boolean(cfg?.dangerouslyUseHTMLString)
      }
    ).then(() => {
      if (cfg?.redirect) {
        router.push(cfg.redirect)
      }
    }).catch(() => {})
  })
})
// 支付回调处理
// 1. 不满足路由条件（非支付回调路由）-> 直接跳过，返回 false 继续执行后续导航守卫逻辑
// 2. 满足路由条件（支付回调路由）-> 等待 userFind 接口结果，再根据 uiStyle 判断走暗黑模式跳转还是继续往下执行
export async function payCallback(userStore, to, next) {
  const darkAppNameUrl = import.meta.env.VITE_DARK_APP_URL;
  const payUrlList = ['/service/checkStandNoLogin', '/service/checkStand'];

  // 不满足路由条件，直接跳过
  if (!payUrlList.some(item => to.path.indexOf(item) !== -1)) {
    return false;
  }

  // 满足路由条件，等待 userFind 接口结果
  const res = await userFind();
  userStore.updateUserInfo(res.data);

  // 暗黑模式跳转逻辑
  if (res.data.uiStyle === 2 && darkAppNameUrl && to?.query?.flag != 1) {
    try {
      const baseUrl = darkAppNameUrl.replace(/\/$/, '');
      const path = to.path.startsWith('/') ? to.path : `/${to.path}`;
      const query = { ...to.query, flag: 1 };
      const queryString = new URLSearchParams(query).toString();

      let finalUrl = `${baseUrl}${path}`;
      if (queryString) {
        finalUrl += `?${queryString}`;
      }

      // 替换当前历史记录，用户点后退不会回到当前页
      window.location.replace(finalUrl);
      return true;
    } catch (error) {
      // URL 构建失败，继续往下执行
      return false;
    }
  }

  // 非暗黑模式或不需要跳转，继续执行后续导航守卫逻辑
  return false;
}
export default router
